import { projectStatusCreationError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getEditProjectStatusError({ uuid }) {
      const req = getState().find(({ status }) => status.uuid === uuid);

      return req ? req.error : projectStatusCreationError;
    },
    isEditProjectStatusRequestFailure({ uuid }) {
      const req = getState().find(({ status }) => status.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditProjectStatusRequestPending({ uuid }) {
      const req = getState().find(({ status }) => status.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditProjectStatusRequestSuccess({ uuid }) {
      const req = getState().find(({ status }) => status.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
